export default __webpack_public_path__ + "static/media/apple-store-badge@3x.7975bf79.png";